import { produce } from 'immer';
import type { AnyAction } from 'redux';
import {
  SET_IS_MOBILE_NAV_OPEN,
  TURN_OFF_BANNER,
  TURN_ON_BANNER,
  SET_SHOW_WHERE_ARE_YOU_MODAL,
  SET_NAVBAR_HEIGHT,
  CLOSE_MOBILE_NAV,
} from './actions';

import { initialState } from './initialState';
import type { UIState } from './types';

export const uiReducer = (
  state = initialState,
  { type, payload }: AnyAction = { type: '', payload: '' },
) =>
  produce<UIState>(state, (draft) => {
    switch (type) {
      case SET_IS_MOBILE_NAV_OPEN:
        draft.isMobileNavOpen = !state.isMobileNavOpen;
        return draft;

      case CLOSE_MOBILE_NAV:
        draft.isMobileNavOpen = false;
        return draft;

      case TURN_ON_BANNER:
        draft.banners[payload] = true;
        return draft;

      case TURN_OFF_BANNER:
        draft.banners[payload] = false;
        return draft;

      case SET_SHOW_WHERE_ARE_YOU_MODAL:
        draft.showWhereAreYouModal = payload.showWhereAreYouModal;
        return draft;

      case SET_NAVBAR_HEIGHT:
        draft.navbarHeight = payload.height;
        return draft;

      default:
        return state;
    }
  });
